import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AppContextProvider } from "./AppContext";
import { registerLicense } from "@syncfusion/ej2-base";
import "./i18n";

registerLicense('ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5SdkNjWn1cc3FSR2Zf;MzAyMDI3N0AzMjM0MmUzMDJlMzBlQmttV0NoRHhzbWxHRkxVMUtMUXB1RDVDQ0hwc3U0NHBXTTBRbktLRVhNPQ==');

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AppContextProvider>
    <App />
  </AppContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
